<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
			<b-col lg="6">
				<!--Display Trash or Normal Table View-->
				<h2>Fluid Transportation Agreement - {{this.subTitle}}</h2>
			</b-col>
			<b-col lg="6">
				<b-dropdown :disabled="edit" class="pull-right" right variant="info" no-caret>
					<template slot="button-content">
								<i class="fa fa-cog"></i>
					</template>
					<b-dropdown-item @click="editAgreement">Edit</b-dropdown-item>
					<b-dropdown-item @click="deleteAgreement" >Delete</b-dropdown-item>
				</b-dropdown>
			</b-col>
		</div>
			<b-card  v-if="loadingData">
				<b-col cols="12" sm="12" md="12" lg="12">
					<p class="text-center">
						<i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
					</p>
				</b-col>
      </b-card>		    
		<div v-else>
			<b-card v-if="found" class="p-0">
				<b-card title="Basic Info" class="p-0 m-0 mb-3">
					<b-row>
								<b-col sm="6">
									<b-form-group :label-cols="3" id="L1" label="Location Based Contract" label-for="radio-group-1" vertical>
										<b-form-radio-group
											v-if="edit"
											id="radio-group-1"
        							v-model="model.located_based"
        							:options="options"
        							plain		
      							></b-form-radio-group>
										<b-form-radio-group
											v-else
											id="radio-group-1"
        							v-model="model.located_based"
        							:options="options"
        							plain	
											disabled
      							></b-form-radio-group>					
									</b-form-group>
								</b-col>
					</b-row>
					<b-row>
								<b-col sm="6">
									<b-form-group :label-cols="3" id="L11" label="Fluid Type Based Contract" label-for="radio-group-4" vertical>
										<b-form-radio-group
											v-if="edit"
											id="radio-group-4"
											v-model="model.fluid_based"
											:options="options"
											plain		
      									></b-form-radio-group>
										<b-form-radio-group
											v-else
											id="radio-group-4"
											v-model="model.fluid_based"
											:options="options"
											plain	
											disabled
      										></b-form-radio-group>					
									</b-form-group>
								</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">
							<b-form-group :label-cols="3" vertical label="Initial Date" label-for="initial_date">
								<b-form-input v-if="!edit" id="initial_date" v-model="model.initial_date" type="text" readonly></b-form-input>
								<b-form-input v-else id="initial_date" v-model="model.initial_date" type="date" :readonly="!edit"></b-form-input>
							</b-form-group>
						</b-col>
						<b-col sm="6">
							<b-form-group :label-cols="3" vertical label="End Date" label-for="end_date">
								<b-form-input v-if="!edit" id="end_date" v-model="model.end_date" type="text" readonly></b-form-input>
								<b-form-input v-else id="end_date" v-model="model.end_date" type="date" :readonly="!edit"></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6" v-if="role =='super_admin'">	
							<b-form-group :label-cols="3" vertical label="Energy Company" label-for="energyCompanies">
								<b-form-select v-if="(role =='super_admin' && edit)" value-field="id" text-field="company_name" id="energyCompanies" v-model="model.energy_company_id" :options="energyCompanies" @input="select_energy_companies" :disabled="!edit">
									<template slot="first"><option :value="null" disabled>-- select energy company --</option></template>
								</b-form-select>
								<b-form-input v-else v-model="model.energy_company" type="text" readonly />
							</b-form-group>				
						</b-col>
						<b-col sm="6">
							<b-form-group :label-cols="3" vertical label="Trucking Company" label-for="truckingCompanies">
								<b-form-select v-if="edit" value-field="id" text-field="name" id="truckingCompanies" v-model="model.trucking_company_id" :options="truckingCompanies" @input="select_trucking_companies" :disabled="!edit">
									<template slot="first"><option :value="null" disabled>-- select trucking company --</option></template>
								</b-form-select>
								<b-form-input v-else v-model="model.trucking_company" type="text" readonly />
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">	
							<b-form-group :label-cols="3" vertical label="Regular Charge" label-for="regular_charge">
								<b-form-select v-if="edit" value-field="id" text-field="name" id="regular_charge" v-model="model.regular_charge_id" :options="chargeTypes" :disabled="!edit">
									<template slot="first"><option :value="null" disabled>-- select regular charge --</option></template>
								</b-form-select>
								<b-form-input v-else v-model="model.regular_charge" type="text" readonly />
							</b-form-group>			
						</b-col>
						<b-col sm="6">
							<b-form-group :label-cols="3" vertical label="Regular Rate" label-for="regular_rate">
								<b-form-input v-if="edit" id="regular_rate" v-model="model.regular_rate" type="text" @keydown.native="myOnlyNumber($event, 'regular_rate')" :readonly="!edit"></b-form-input>
								<b-form-input v-else v-model="model.regular_rate1" type="text" readonly />
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">	
							<b-form-group :label-cols="3" vertical label="Standby Time Charge" label-for="stb_charge">
								<b-form-select v-if="edit" value-field="id" text-field="name" id="stb_charge" v-model="model.stb_charge_id" :options="chargeTypes" :disabled="!edit">
									<template slot="first"><option :value="null" disabled>-- select standby time charge --</option></template>
								</b-form-select>
								<b-form-input v-else v-model="model.stb_charge" type="text" readonly />
							</b-form-group>			
						</b-col>
						<b-col sm="6">
							<b-form-group :label-cols="3" vertical label="Standby Time Rate" label-for="stb_rate">
								<b-form-input v-if="edit" id="stb_rate" v-model="model.stb_rate" type="text" @keydown.native="myOnlyNumber($event, 'stb_rate')"  :readonly="!edit"></b-form-input>
								<b-form-input v-else v-model="model.stb_rate1" type="text" readonly />
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">	
							<b-form-group :label-cols="3" vertical label="Worktime Charge" label-for="worktime_charge">
								<b-form-select v-if="edit" value-field="id" text-field="name" id="worktime_charge" v-model="model.worktime_charge_id" :options="chargeTypes" :disabled="!edit">
									<template slot="first"><option :value="null" disabled>-- select worktime charge --</option></template>
								</b-form-select>
								<b-form-input v-else v-model="model.worktime_charge" type="text" readonly />
							</b-form-group>			
						</b-col>
						<b-col sm="6">
							<b-form-group :label-cols="3" vertical label="Worktime Rate" label-for="worktime_rate">
								<b-form-input v-if="edit" id="worktime_rate" v-model="model.worktime_rate" type="text" @keydown.native="myOnlyNumber($event, 'worktime_rate')"  :readonly="!edit"></b-form-input>
								<b-form-input v-else v-model="model.worktime_rate1" type="text" readonly />
							</b-form-group>
						</b-col>
					</b-row>
					<b-row>
						<b-col sm="6">
						<b-form-group :label-cols="3" id="L2" label="Wait Time Discount?" label-for="radio-group-2" vertical>
							<b-form-radio-group
								v-if="edit"
								id="radio-group-2"
        				v-model="model.wait_time_discount"
        				:options="options"
        				plain
      			></b-form-radio-group>
							<b-form-radio-group
								v-else
								id="radio-group-2"
        				v-model="model.wait_time_discount"
        				:options="options"
        				plain
								disabled
      				></b-form-radio-group>
						</b-form-group>
						<b-form-group :label-cols="3" id="L3" label="Would you like to round to the nearest 15min? " label-for="radio-group-3" vertical>
							<b-form-radio-group
								v-if="edit"
								id="radio-group-3"
        				v-model="model.rounding"
        				:options="options"
        				plain
      				></b-form-radio-group>	
							<b-form-radio-group
								v-else
								id="radio-group-3"
        				v-model="model.rounding"
        				:options="options"
        				plain
								disabled
      				></b-form-radio-group>					
						</b-form-group>
						</b-col>
						<b-col sm="6" v-if="model.regular_charge_id != '' && model.regular_rate != '0.00'">
							<b-form-group :label-cols="3" vertical label="Chain Up Rate" label-for="chain_up_rate">
								<b-form-input v-if="edit" id="chain_up_rate" v-model="model.chain_up_rate" type="text" @keydown.native="myOnlyNumber($event, 'chain_up_rate')" :readonly="!edit"></b-form-input>
								<b-form-input v-else v-model="model.chain_up_rate1" type="text" readonly />
							</b-form-group>
						</b-col>
					</b-row>
				</b-card>
				<!-- Truck Types -->
				<b-card title="Truck Types" class="p-0 m-0 mb-3">
					<div v-if="edit">
							<b-form-group v-if="truckTypes.length > 0" :label-cols="1" id="L4" label="" label-for="truck_types" vertical>
								<b-form-checkbox-group value-field="id" text-field="name" class="custom-checkboxes" :options="truckTypes" name="Checkboxes2" plain v-model="model.truck_type_id" @input="trucktypesChange"></b-form-checkbox-group>
								<b-form-checkbox style="margin-top: 15px;" v-model="ttAllSelected" :indeterminate="indeterminateTT" aria-describedby="" aria-controls="" plain @change="ttToggleAll">
									{{ ttAllSelected ? 'Un-select All' : 'Select All' }}
								</b-form-checkbox>
							</b-form-group>
							<p v-else>{{model.trucking_company_id != null ? 'There are no registered Truck Types for the selected Trucking Company' : 'No Trucking Company selected'}}</p>	
					</div>
					<div v-else>
						<b-form-group v-if="model.truck_types.length > 0" :label-cols="1" id="L5" label="" label-for="truck_types" horizontal>
							<b-form-checkbox-group text-field="name" class="custom-checkboxes" :options="model.truck_types" name="Checkboxes2" plain :checked="true" disabled></b-form-checkbox-group>
						</b-form-group>
						<p v-else>No Truck Types have been added</p>
					</div>
				</b-card>
				<!-- Load Location Types -->
				<b-card v-if="model.located_based =='true'" title="Load Location" class="p-0 m-0 mb-3">
					<div v-if="edit">
							<b-form-group v-if="loadlocationselect.length > 0" :label-cols="1" id="L6" label="" label-for="load_locations" vertical>
								<b-form-checkbox-group value-field="id" text-field="legal_location" class="custom-checkboxes" :options="loadlocationselect" name="Checkboxes2" plain v-model="model.load_locations_id" @input="loadLocationsChange"></b-form-checkbox-group>
								<b-form-checkbox style="margin-top: 15px;" v-model="llAllSelected" :indeterminate="indeterminateLL" aria-describedby="" aria-controls="" plain @change="llToggleAll">
									{{ llAllSelected ? 'Un-select All' : 'Select All' }}
								</b-form-checkbox>
							</b-form-group>
							<p v-else>{{model.energy_company_id != null ? 'There are no registered Load Locations for the selected Energy Company' : 'No Energy Company selected'}}</p>	
					</div>
					<div v-else>
						<b-form-group v-if="model.load_locations.length > 0" :label-cols="1" id="L7" label="" label-for="load_locations" horizontal>
							<b-form-checkbox-group text-field="legal_location" class="custom-checkboxes" :options="model.load_locations" name="Checkboxes2" plain :checked="true" disabled></b-form-checkbox-group>
						</b-form-group>
						<p v-else>No Load Locations have been added</p>
					</div>
				</b-card>
				<!-- Unload Location Types -->
				<b-card v-if="model.located_based =='true'" title="Unload Location" class="p-0 m-0 mb-3">
					<div v-if="edit">
							<b-form-group v-if="unloadlocationselect.length > 0" :label-cols="1" id="L8" label="" label-for="unload_locations" vertical>
								<b-form-checkbox-group value-field="id" text-field="legal_location" class="custom-checkboxes" :options="unloadlocationselect" name="Checkboxes2" plain v-model="model.unload_locations_id" @input="unloadLocationsChange"></b-form-checkbox-group>
								<b-form-checkbox style="margin-top: 15px;" v-model="ulAllSelected" :indeterminate="indeterminateUL" aria-describedby="" aria-controls="" plain @change="ulToggleAll">
									{{ ulAllSelected ? 'Un-select All' : 'Select All' }}
								</b-form-checkbox>
							</b-form-group>
							<p v-else>There are no registered Unload Locations</p>	
					</div>
					<div v-else>
						<b-form-group v-if="model.unload_locations.length > 0" :label-cols="1" id="L9" label="" label-for="unload_locations" horizontal>
							<b-form-checkbox-group text-field="legal_location" class="custom-checkboxes" :options="model.unload_locations" name="Checkboxes2" plain :checked="true" disabled></b-form-checkbox-group>
						</b-form-group>
						<p v-else>No Unload Locations have been added</p>
					</div>
				</b-card>
				<b-card v-if="model.fluid_based =='true'" title="Fluid Types" class="p-0 m-0 mb-3">
					<div v-if="edit">
							<b-form-group v-if="fluidtypeselect.length > 0" :label-cols="1" id="L10" label="" label-for="fluid_types" vertical>
								<b-form-checkbox-group value-field="id" text-field="name" class="custom-checkboxes" :options="fluidtypeselect" name="Checkboxes2" plain v-model="model.fluid_types_id" @input="fluidtypesChange()"></b-form-checkbox-group>
								<b-form-checkbox style="margin-top: 15px;" v-model="ftAllSelected" :indeterminate="indeterminateFT" aria-describedby="" aria-controls="" plain @change="ftToggleAll">
									{{ ftAllSelected ? 'Un-select All' : 'Select All' }}
								</b-form-checkbox>
							</b-form-group>
							<p v-else>No Fluid Types registered</p>	
					</div>
					<div v-else>
						<b-form-group v-if="model.fluid_types.length > 0" :label-cols="1" id="L11" label="" label-for="fluid_types" horizontal>
							<b-form-checkbox-group text-field="name" class="custom-checkboxes" :options="model.fluid_types" name="Checkboxes2" plain :checked="true" disabled></b-form-checkbox-group>
						</b-form-group>
						<p v-else>No Fluid Types have been added</p>
					</div>
				</b-card>
				<div v-if="edit" slot="footer">
					<b-button v-show="edit" @click="updateAgreement" size="sm" variant="primary"><i class="fa fa-edit"></i> Update</b-button>
					<b-button v-show="edit" @click="editAgreement" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancel</b-button>
				</div>
			</b-card>
			<b-row v-else>
				<b-col cols="12" sm="12" md="12" lg="12">
					<br>
					<p class="text-center text-danger">
						<i class="icon fa-lg icon-puzzle"></i><br>{{notFoundMessage}}
					</p>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
	// ********** imports ************ //
	import Vue from 'vue'
	import vSelect from 'vue-select'
	import axios from 'axios'
	import {
		apiDomain
	} from '../../config'
	import agreements_service from './agreements_service'
	import target_service from '../m_targets/targets'

	Vue.component('v-select', vSelect)

	export default {
		name: 'm_location',
		props: {
			id: {
				type: String,
				default: 0
			}
		},
		created: function() {
			this.getAgreementData()
		},
		data() {
			return {
				rate: '',
				chain_up_rate: '',
				chargeTypes						: [],
				energyCompanies				: [],
				truckingCompanies			: [],
        originalData					: null,
        updateDate						: null,
				edit									: false,
				subTitle							: "",
				loadingData						: true,
				tabIndex: 0,
				found									: false,
        notFoundMessage				: 'Not found',
				role									:	'',
				view:true,
				energy_company_iidd 	:	null,
				model:{
					id									: null,
					energy_company			: '',
					energy_company_id		: null,
					trucking_company    	: '',
					trucking_company_id 	: null,
					initial_date			: null,
					end_date				: null,
					regular_charge  		: '',
					regular_charge_id		: null,
					regular_rate			: null,
					stb_charge_id			: null,
					stb_rate				: null,
					worktime_charge_id		: null,
					worktime_rate			: null,
					chain_up_rate			: null,
					truck_types  			: [],
					truck_type_id			: [],
					unload_locations_id		: [],
					load_locations_id		: [],
					load_locations  		: [],
					unload_locations 		: [],
					hauls 					: [],
					located_based			: 'false',
					rounding 				: 'false',
					wait_time_discount 		: 'false',
					fluid_based			    : 'false',
					fluid_types_id          : [],
					fluid_types  			: [],
				},
				options: [
					{ text: 'Yes', value: 'true' },
					{ text: 'No', value: 'false' },
				],
				truckTypes					: [],
				indeterminateTT				: false,
				ttAllSelected				: false,
				loadlocationselect			: [],
				indeterminateLL				: false,
				llAllSelected				: false,
				unloadlocationselect		: [],
				indeterminateUL				: false,
				ulAllSelected				: false,
				fluidtypeselect				: [],
				indeterminateFT				: false,
				ftAllSelected				: false,
			}
		},
		methods: {
				unloadLocationsChange() {
					if (this.role =='super_admin') {
						if (this.model.unload_locations_id.length === 0) {
						this.indeterminateUL = false
						this.ulAllSelected = false
						} else if (this.model.unload_locations_id.length === this.unloadlocationselect.length) {
						this.indeterminateUL = false
						this.ulAllSelected = true
						} else {
						this.indeterminateUL = true
						this.ulAllSelected = false
						}
					}
				},
				ulToggleAll(checked) {
					this.model.unload_locations_id = checked ? this.unloadlocationselect.map(item => {
						return item.id
					}) : []
			  	},
				loadLocationsChange() {
					if (this.role =='super_admin') {
						if (this.model.load_locations_id.length === 0) {
						this.indeterminateLL = false
						this.llAllSelected = false
						} else if (this.model.load_locations_id.length === this.loadlocationselect.length) {
						this.indeterminateLL = false
						this.llAllSelected = true
						} else {
						this.indeterminateLL = true
						this.llAllSelected = false
						}
					}
				},
				llToggleAll(checked) {
					this.model.load_locations_id = checked ? this.loadlocationselect.map(item => {
						return item.id
					}) : []
				},
				trucktypesChange() {
					if (this.role =='super_admin') {
						if (this.model.truck_type_id.length === 0) {
						this.indeterminateTT = false
						this.ttAllSelected = false
						} else if (this.model.truck_type_id.length === this.truckTypes.length) {
						this.indeterminateTT = false
						this.ttAllSelected = true
						} else {
						this.indeterminateTT = true
						this.ttAllSelected = false
						}
					}
				},
				ttToggleAll(checked) {
					this.model.truck_type_id = checked ? this.truckTypes.map(item => {
						return item.id
					}) : []
				},
      select_energy_companies() {
				this.truckTypes = []
				this.indeterminateLL	= false
				this.llAllSelected		= false
				this.model.load_locations_id	= []
        let energycompanies = this.updateDate.energy_companies
        let energy_company_index = energycompanies.map(o => o.id).indexOf(this.model.energy_company_id)
        if (energy_company_index > -1) {
			this.loadlocationselect  = energycompanies[energy_company_index]['load_locations']
			this.unloadlocationselect = energycompanies[energy_company_index]['unload_locations']
          let trucking_companies = energycompanies[energy_company_index]['trucking_companies']
          this.truckingCompanies = trucking_companies
					// SAME as in APP - Select if there is only one item in the array
          if (this.truckingCompanies.length == 1) {
            this.model.trucking_company_id  = this.truckingCompanies[0].id
            let trucking_companies = energycompanies[energy_company_index]['trucking_companies']
            let trucking_company_index = trucking_companies.map(o => o.id).indexOf(this.model.trucking_company_id)
            if (trucking_company_index > -1) {
              let truck_types = trucking_companies[trucking_company_index]['truck_types']
              this.truckTypes = truck_types
            }
          } else {
							this.model.trucking_company_id  = null
					}
        }

      },
      select_trucking_companies() {
				this.indeterminateTT				= false
				this.ttAllSelected					= false
				this.model.truck_type_id		= []
        let energycompanies 				= this.updateDate.energy_companies
        let energy_company_index 		= energycompanies.map(o => o.id).indexOf(this.model.energy_company_id)
        if (energy_company_index > -1) {
          let trucking_companies = energycompanies[energy_company_index]['trucking_companies']
          let trucking_company_index = trucking_companies.map(o => o.id).indexOf(this.model.trucking_company_id)
          if (trucking_company_index > -1) {
            let truck_types = trucking_companies[trucking_company_index]['truck_types']
            this.truckTypes = truck_types
          }
        }
      },
      setupFields() {
        let chargetypes 			= this.updateDate.charge_types
        this.chargeTypes 			= chargetypes

        let energycompanies 	= this.updateDate.energy_companies
        this.energyCompanies 	= energycompanies

        let energy_company_index = energycompanies.map(o => o.id).indexOf(this.model.energy_company_id)
        if (energy_company_index > -1) {
					this.loadlocationselect  = energycompanies[energy_company_index]['load_locations']
					this.unloadlocationselect = energycompanies[energy_company_index]['unload_locations']
					let trucking_companies = energycompanies[energy_company_index]['trucking_companies']
					this.truckingCompanies = trucking_companies

					let trucking_company_index = trucking_companies.map(o => o.id).indexOf(this.model.trucking_company_id)
					if (trucking_company_index > -1) {
						let truck_types = trucking_companies[trucking_company_index]['truck_types']
						this.truckTypes = truck_types
					}
		}
		this.model.truck_type_id = this.model.truck_types.map(item => {
																	return item.id
																})
		this.trucktypesChange()
		this.model.load_locations_id = this.model.load_locations.map(item => {
																	return item.id
																})
		this.loadLocationsChange() 
		this.model.unload_locations_id = this.model.unload_locations.map(item => {
																	return item.id
																})
		this.unloadLocationsChange() 
		this.fluidtypesChange() 
      },
			editAgreement() {
				if (this.edit) {
					this.edit = false
					this.restoreOriginalData()
				} else {
          this.setupFields()
					this.edit = true
				}
			},
			restoreOriginalData() {

				let model = {
					...this.originalData,
				}
				this.model = JSON.parse(JSON.stringify(model))
      },
      okToUpdate() {
					if (this.role =='super_admin') {
						if( this.model.energy_company_id == null) {
							this.$swal('Alert!', 'Energy Company not selected', 'warning')
							return false
						}
					}
					if(this.model.initial_date === undefined || this.model.initial_date == null) {
						this.$swal('Alert!', 'Initial Date not selected', 'warning')
						return false
					} else if(this.model.end_date === undefined || this.model.end_date == null) {
						this.$swal('Alert!', 'End Date not selected', 'warning')
						return false
					} else if(this.model.trucking_company_id === undefined || this.model.trucking_company_id  == null) {
						this.$swal('Alert!', 'Trucking Company not selected', 'warning')
						return false
					} else if(this.model.regular_charge_id === undefined || this.model.regular_charge_id == null) {
						this.$swal('Alert!', 'Regular Charge Type not selected', 'warning')
						return false
					} else if(this.model.regular_rate === undefined || this.model.regular_rate == null || this.model.regular_rate == '') {
						this.$swal('Alert!', 'Regular Rate can not be empty', 'warning')
						return false
					} else if(this.model.truck_type_id.length == 0) {
						this.$swal('Alert!', 'Truck Types not selected', 'warning')
						return false
					} else if(this.model.stb_charge_id === undefined || this.model.stb_charge_id == null) {
						this.$swal('Alert!', 'Standby Time Charge Type not selected', 'warning')
						return false
					} else if(this.model.stb_rate === undefined || this.model.stb_rate == null || this.model.stb_rate == '') {
						this.$swal('Alert!', 'Standby Time Rate can not be empty', 'warning')
						return false
					} else if(this.model.worktime_charge_id === undefined || this.model.worktime_charge_id == null) {
						this.$swal('Alert!', 'Worktime Charge Type not selected', 'warning')
						return false
					} else if(this.model.worktime_rate === undefined || this.model.worktime_rate == null || this.model.worktime_rate == '') {
						this.$swal('Alert!', 'Worktime Rate can not be empty', 'warning')
						return false
					} else if(this.model.located_based	 == 'true' && this.model.load_locations_id.length == 0) {
						this.$swal('Alert!', 'Load Location not selected', 'warning')
						return false
					} else if(this.model.located_based	 == 'true' && this.model.unload_locations_id.length == 0) {
						this.$swal('Alert!', 'Unload Location not selected', 'warning')
						return false
					} else if(this.model.fluid_based	 == 'true' && this.model.fluid_types_id.length == 0) {
						this.$swal('Alert!', 'Fluid Types not selected', 'warning')
						return false
					}
        return true
      },
      updateAgreement () {
        if(!this.okToUpdate()) {
          return
				}
		if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
			this.model.energy_company_id = this.energy_company_iidd 
		}
		if(this.model.fluid_based	 == 'true') {
			let fluid_types_id =   this.model.fluid_types_id   
			let new_fluid_types = []
			let index = -1
			fluid_types_id.forEach(e => {
				if (this.fluidtypeselect.length != 0) {
					index = this.fluidtypeselect.map(o => o.id).indexOf(e)
					if (index>-1) {
						new_fluid_types.push(this.fluidtypeselect[index])
					} 
				}
			})
			this.model.fluid_types = new_fluid_types
		}
        agreements_service.update( this.model.id, this.model)
        .then(data => {
          this.$swal(data[0], data[1], data[0])
            .then((result) => {
              if (data[0] == 'success') {
                this.getAgreementData()
								this.edit = false
              }
            })
        })
        .catch(error => {
          this.$swal('Error', 'Server not response. ' + error, 'error')
        })   
      },
      deleteAgreement() {
				this.$swal({
					title: 'Please, confirm',
					text: "Are you sure to delete this Agreement: " + this.subTitle + " ?",
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes',
          reverseButtons: true
				}).then((result) => {
					if (result.value) {
						agreements_service.delete(this.id, this.model.hauls)
							.then(data => {
								this.$swal(data[0], data[1], data[0])
								if (data[0] == 'success') {
									this.$router.replace('/agreements')
								}
							})
							.catch(error => {
								this.$swal('Error', 'Server not response. ' + error, 'error')
							})
					}
				})
				this.edit = false
			},
			getAgreementData() {
				agreements_service.getBy(this.id)
					.then(data => {
            			if (data[0] == 'success') {
							this.originalData 			= data[1]
							this.updateDate 			= data[2]
							// this.unloadlocationselect  	= this.updateDate.locations_unload
							this.fluidtypeselect  		= this.updateDate.fluid_types
						  	this.restoreOriginalData()
						  	this.subTitle 				= this.originalData.energy_company
						  	this.found 					= true
              				this.loadingData 			= false
            				this.role 					= data[3]
							if (this.role =='super_admin') {
								this.view	=true
							} else if (this.role =='super_analyst' || this.role =='analyst' || this.role =='marketing_accountant') {
								this.view	=false
								this.energy_company_iidd = data[4]
							}
						} else {
											this.$swal(data[0], data[1], data[0])
											this.loadingData = false
						}
					})
					.catch(error => {
						this.$swal('Error', 'Server not response. ' + error, 'error')
						this.loadingData = false
					})
			},
      myOnlyNumber(evt, variableName) {
					let dotPosition = this.model[variableName].indexOf(".")
					let hasDot = dotPosition > -1
					let length = this.model[variableName].length
					this.isNumber(evt, hasDot, dotPosition, length)
      },
      isNumber: function(evt, hasDot, dotPosition, length) {
				evt = (evt) ? evt : window.event;
				var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode <= 31 || charCode == 37 || charCode == 39 || (charCode >= 96 && charCode <= 105) || ((charCode >= 48 && charCode <= 57) || charCode === 46 || charCode === 19 || (!hasDot && charCode == 190)|| (!hasDot && charCode == 110))) {
          let selectionStart = evt.target.selectionStart;
          let selectionEnd = evt.target.selectionEnd;
          if ((hasDot && (selectionEnd > dotPosition && selectionStart > dotPosition && selectionEnd == selectionStart ) && length - 2 > dotPosition) && charCode > 31 && (charCode != 37 && charCode != 39)) {
            evt.preventDefault();
          } else {
            return true
          }
        } else {
          evt.preventDefault();
        }
      },
	  		ftToggleAll(checked) {
				this.model.fluid_types_id = checked ? this.fluidtypeselect.map(item => {
					return item.id
				}) : []
			},
			fluidtypesChange() {
				if (this.model.fluid_types_id.length === 0) {
					this.indeterminateFT = false
					this.ftAllSelected = false
				} else if (this.model.fluid_types_id.length === this.fluidtypeselect.length) {
					this.indeterminateFT = false
					this.ftAllSelected = true
				} else {
					this.indeterminateFT = true
					this.ftAllSelected = false
				}
			},
		}
	}
</script>
<style scoped>
	/deep/ .col-form-label{
		font-weight: bold;
	}

	.card-body, .card-block, .card-block {
    	padding: 0.3rem;
	}
	.card-body >>> .b-table.table.b-table-stacked > tbody > tr > [data-label] {
		display: grid;
		grid-template-columns: 16% 84%;
		grid-gap: 0.25rem 1rem;
	}
	.form-control:disabled, .form-control[readonly] {
		background-color: #f7fbfd;
		opacity: 1;
		color: #000000;
	}
/deep/	.custom-checkboxes .form-check-inline {
	 width: 35vh;
	}
/deep/	.custom-checkboxes .form-check-label {
    	overflow: unset;
	}
</style>


// WEBPACK FOOTER //
// src/views/agreements/agreement.vue